import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../../xform-compat';
import { CONFIG } from '../../../config';
import { RmsBasicCrudService } from '../../components/rms-basic-crud.service';
import { CompanyLink, LinkType, QuickLink } from '../../../shared/models';


/**
 * Injectable service for company links
 */
@Injectable({
  providedIn: 'root'
})
export class CompanyLinksService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Get the links for a company
   * @param {number} companyId
   * @param params
   * @returns {Observable<PaginatedList<CompanyLink>>}
   */
  public getCompanyLinks (companyId: number, params?: any): Observable<PaginatedList<QuickLink>> {
    return this.getData(`${CONFIG.apiUrl}/rms/companies/${companyId}/links`, params);
  }

  /**
   * Gets all the link types
   * @param params
   * @returns {Observable<PaginatedList<LinkType>>}
   */
  public getLinkTypes (params?: any): Observable<PaginatedList<LinkType>> {
    return this.getData(`${CONFIG.apiUrl}/rms/linktypes`, params);
  }

  /**
   * Creates a new company link
   * @param {number} companyId
   * @param body
   * @returns {Observable<CompanyLink>}
   */
  public createCompanyLinks (companyId: number, body: any): Observable<CompanyLink> {
    return this.saveData(`${CONFIG.apiUrl}/rms/companies/${companyId}/links`, body);
  }

  /**
   * Updates a company link
   * @param {number} companyId
   * @param companyLinkId
   * @param body
   * @returns {Observable<CompanyLink>}
   */
  public updateCompanyLinks (companyId: number, companyLinkId, body: any): Observable<CompanyLink> {
    return this.updateData(`${CONFIG.apiUrl}/rms/companies/${companyId}/links/${companyLinkId}`, body);
  }

  /**
   * Deletes a company link
   * @param {number} companyId
   * @param {number} linkId
   * @returns {Observable<CompanyLink>}
   */
  public deleteCompanyLink (companyId: number, linkId: number): Observable<CompanyLink> {
    return this.deleteData(`${CONFIG.apiUrl}/rms/companies/${companyId}/links/${linkId}`);
  }

  /**
   * Sort list of company links when drag and drop
   * @param {number} companyId
   * @param body
   * @returns {Observable<null>}
   */
  public sortCompanyLinks (companyId: number, body: Array<{id: number, order: number}>): Observable<null> {
    return this.updateData(`${CONFIG.apiUrl}/rms/companies/${companyId}/links/sort`, body);
  }

}
